export class PaymentRequestFilter {
  RemittanceInformation: string;
  StatusCode: number;
  CompanyId?: number;
  IsUpgradeCreditRequest: boolean;

  constructor(companyId?: number) {
    this.RemittanceInformation = null;
    this.StatusCode = null;
    this.CompanyId = null;
    this.IsUpgradeCreditRequest = false;

    if (companyId) {
      this.CompanyId = companyId;
    }
  }
}
